import { Fragment, useEffect, useState } from "react";
import Select from "react-select";
import { useWarehousesQuery } from "../../../services/warehouseApi";
// import customStyles from "./SelectFeild";
import { signInUser } from "../../Utility/Auth";

const WareHouseDW = ({ warehouse, handleOnChange, name, value, wh }) => {
  const auth = signInUser();
  const { aamarId } = auth;
  const { data, error, isLoading, isFetching, isSuccess } = useWarehousesQuery({
    aamarId,
  });
  // console.log(warehouse);
  let [warehouseOption, setWarehouseOption] = useState([]);
  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused
        ? "#0d6efd" // Background color on hover
        : state.isSelected
        ? "#fff" // Background color when selected (red)
        : "transparent", // Default background color
      color: state.isFocused
        ? "#fff" // White text color on hover
        : state.isSelected
        ? "#000" // White text color when selected
        : "#000", // Default black text color
      padding: "10px 15px", // Padding for better spacing

      transition: "background-color 0.2s ease, color 0.2s ease", // Smooth transition for background and text color
    }),
    control: (provided) => ({
      ...provided,
      // width: "216px", // Set custom width
      // maxWidth: "100%",
      borderRadius: "6px",
      // Optional: Customize the input control here
    }),

    // menu: (provided) => ({
    //   ...provided,
    //   borderRadius: "5px", // Rounded corners for the dropdown menu
    //   color: "#000", // Black text color

    //   // High z-index to ensure it appears above other elements
    //   // Ensure proper stacking context
    // }),
  };

  // console.log(data);
  useEffect(() => {
    let warehouseOptions = [
      { option: "no-warehouse", label: "All Warehouse", index: name },
    ];
    if (isSuccess && data && data.length > 0) {
      data.map((warehouse) => {
        warehouseOptions = [
          ...warehouseOptions,
          {
            option: warehouse._id,
            label: `${warehouse.name}`,
            index: name,
          },
        ];
      });
    }
    setWarehouseOption(warehouseOptions);
  }, [data, isSuccess, name]);

  return (
    <Fragment>
      <Select
        className="basic-single"
        classNamePrefix="select"
        defaultValue={warehouseOption[0]}
        value={
          warehouse &&
          warehouseOption[
            warehouseOption.map((obj) => obj.option).indexOf(warehouse)
          ]
        }
        isDisabled={false}
        isLoading={false}
        isClearable={false}
        isSearchable={true}
        name={name}
        onChange={(e) => handleOnChange(e)}
        options={warehouseOption}
        placeholder="All Warehouse"
        styles={customStyles}
      />
    </Fragment>
  );
};

export default WareHouseDW;
